import { Grid } from '@mui/material';
import React from 'react';
import '../../assets/css/accountmetrics.scss';
import Title from './title';
import brp from "../../assets/images/brp.svg";
import usd from "../../assets/images/usd.svg";
import { dollarUS } from "../../utilities/formatters";
import Flag from 'react-world-flags'; 

// Function to format numbers
const NumberFormatter = (num, formatter=undefined) => {
  let data = parseInt(num);
  const classlist = data < 0 ? "Negative" : data >= 0 ? "Positive" : "Number";
  if (formatter) return <div className={classlist}>{formatter(num)}</div>;
  return <div className={classlist}>{num}</div>;
};

const currencyNames = {
  USD: 'US Dollar',
  CAD: 'Canadian Dollar',
  EUR: 'Euro',
  JPY: 'Japanese Yen',
  GBP: 'British Pound',
  AUD: 'Australian Dollar',
  CHF: 'Swiss Franc',
  NZD: 'New Zealand Dollar',
  
};


const AMStatCards = (props) => {
  const currencyName = props.AMCurrencyName.replace('.pro', ''); 
  const currencyPair = currencyName.slice(0, 3) + '/' + currencyName.slice(3, 6);
  const currency1 =  currencyName.slice(0, 3)
  const currency2 = currencyName.slice(3 , 6)
  const countryCode1 = currencyName.slice(0, 2); // "AU"
  const countryCode2 = currencyName.slice(3, 5); // "JP"
  // Get full currency names
  const currencyFullName1 = currencyNames[currency1] || currency1;
  const currencyFullName2 = currencyNames[currency2] || currency2;

  return (
    <div className={`AMStatCards ${props.tradelots ? "AMStatCardsTradelots" : "AMStatCardsStats" }`}>
      <Grid container>
 
        <Grid>
          <Grid className="CardName">
          <Grid xs={2} gap={'4px'}>
          <div style={{display:'flex' , gap:'4px' , alignItems:'center'
          }} className="FCountry">
            <Flag code={countryCode1} style={{ width: 18, height: 18 , borderRadius:"100%" , objectFit:"cover" }} />
            {currency1}
          </div>/
          <div style={{display:'flex' , gap:'4px' , alignItems: 'center'}} className="LCountry">
            <Flag code={countryCode2} style={{ width: 18, height: 18 , borderRadius:'100%' , objectFit:"cover" }} />
            {currency2}
          </div>
        </Grid>
            
            </Grid>
          <Title three>
            <span className='currency_name' style={{ textTransform: "uppercase" }}>
            {currencyFullName1} / {currencyFullName2}
            </span>
          </Title>
        </Grid>
      </Grid>
      <div container className='stats_wrapper'>
        <div className="StatNumOne">{props.Num1}</div>
        <div className="StatNumTwo">
          {NumberFormatter(props.Num3, dollarUS)}
          {NumberFormatter(props.Num2)}
        </div>
      </div>
    </div>
  );
};

export default AMStatCards;
